import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href", "href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'UseSvg',
  props: {
    svgId: {},
    svgFileName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", null, [
    _createElementVNode("use", {
      "xlink:href": `#${_ctx.svgId}`,
      href: `#${_ctx.svgId}`
    }, null, 8, _hoisted_1)
  ]))
}
}

})